export default __webpack_public_path__ + "static/media/telegram_line.e57a2aa3.svg";